<template>
  <div class="trend-chart">
    <v-chart :options="options" />
    <slot></slot>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
// import 'echarts/lib/component/title'

export default {
  data() {
    return {
      KEY_NAME_OBJ: {
        assuranceAmount: '担保额度',
        insuranceAmount: '保险额度',
        limitAmount: '总信用限额',
        validAmount: '当前有效额度',
        limitConditionAmount: '每日限额条件',
        notStartedLimitAmount: '未生效限额',
      },
    }
  },
  props: ['dataSource'],
  computed: {
    options() {
      const dataSource = this.dataSource
      const xAxisData = []
      const seriesObj = {
        assuranceAmount: [],
        insuranceAmount: [],
        limitAmount: [],
        validAmount: [],
        limitConditionAmount: [],
        notStartedLimitAmount: [],
      }
      dataSource.forEach(element => {
        xAxisData.push(element.time)
        Object.keys(element).forEach(key => {
          if (seriesObj[key]) {
            seriesObj[key].push(element[key])
          }
        })
      })
      const options = {
        color: [
          '#c23531',
          '#FFCC33',
          '#009ad6',
          '#8552a1',
          '#57b13a',
          '#f7acbc',
        ],
        xAxis: {
          type: 'category',
          data: xAxisData,
        },
        // title: {
        //   text: '信用趋势'
        // },
        legend: {
          top: 10,
          data: [
            '担保额度',
            '保险额度',
            '总信用限额',
            '当前有效额度',
            '每日限额条件',
            '未生效限额',
          ],
          itemGap: 20,
          // data: ['担保额度', '保险额度', '总信用限额', '当前有效额度'],
        },
        yAxis: {
          type: 'value',
          name: '金额(元)',
        },
        series: Object.keys(seriesObj).map(key => {
          return {
            name: this.KEY_NAME_OBJ[key],
            data: seriesObj[key],
            type: 'line',
          }
        }),
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: '10%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
      }
      return options
    },
  },
  components: {
    'v-chart': ECharts,
  },
}
</script>

<style lang="less" scoped>
.trend-chart {
  .echarts {
    display: inline-block;
    vertical-align: middle;
    width: 800px;
    height: 500px;
  }
}
</style>
